import { Component, OnInit, ViewEncapsulation } from '@angular/core';
// import { makeStateKey, TransferState } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
// import { SharedService } from 'src/app/modules/shared/_services/shared.service';

import { PARAMS } from 'src/app/_configs/params';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-explore-by-states',
  templateUrl: './explore-by-states.component.html',
  styleUrls: ['./explore-by-states.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class ExploreByStatesTendersComponent implements OnInit {
  baseUrl: string = environment.TENDER.BASE_URL;
  freshTenders: Array<any> = [];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.resolveTenderNewMain()
  }

  resolveTenderNewMain() {
    this.activatedRoute.data.subscribe((rawData: any) => {
      let resolverData: any = rawData['tendersResolver'];
      if (resolverData) {
        this.freshTenders = resolverData?.states?.data;
      }
    });
  }

  viewAll() {
    this.router.navigate(
      [PARAMS.ROUTING_PATHS.ALL_TENDERS_ACTIVE], {});
  }
}
